export function Stat({ label, value, sub }) {
  return (
    <div className="rounded-2xl bg-white/60 backdrop-blur border border-white/60 shadow-sm p-4">
      <div className="text-xs font-medium text-slate-500">{label}</div>
      <div className="mt-1 text-lg font-extrabold text-slate-900">{value}</div>
      {sub ? <div className="mt-1 text-xs text-slate-500">{sub}</div> : null}
    </div>
  );
}